import React, { useContext, useEffect } from 'react'
import Layout from '../../../components/layout/layout'
import './mlrolehealth.scss'
import mlroleHealthImage from '../../../images/articles/mlrole-health.jpg'
import mlroleHealthImage2 from '../../../images/articles/mlrole-health2.jpg'
import { LanguageContext } from '../../../components/LanguageSwitcher/LanguageContext'
import { ArticleBackLink, ArticleNextCta } from '../../../components/ArticleNav/ArticleNav'
import ArticleCta from '../../../components/ArticleCta/ArticleCta'
import ArticleListen from '../../../components/ArticleListen/ArticleListen'
import ArticleSummary from '../../../components/ArticleSummary/ArticleSummary'
import Seo, { articleJsonLd, articleBreadcrumbs } from '../../../components/Seo/Seo'

const Mlrolehealth = () => {
  const { translations } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);

  return (
    <Layout>
      <Seo
        title='Machine Learning in Healthcare: What Works Now'
        description={translations.BlogmlroleHealth1}
        type='article'
        image={mlroleHealthImage}
        jsonLd={[
          articleJsonLd({ headline: translations.BlogmlroleHealth, description: translations.BlogmlroleHealth1, datePublished: '2024-10-03', dateModified: '2026-09-18', author: translations.BlogmlroleHealth13 }),
          articleBreadcrumbs(translations.BlogmlroleHealth, '/articles/mlrolehealth'),
        ]}
      />
      <div className='mlrole-health-container'>
        <div className='mlrole-health healthh-box'>
          <ArticleBackLink />
          <h1 className='article-main-title'>{translations.BlogmlroleHealth}</h1>
          <div className='article-author-head-container'>
            <div className='article-author-head'>
              <p>{translations.BlogmlroleHealth12}</p>
              <p>•</p>
              <p>{translations.BlogmlroleHealth13}</p>
            </div>

            <p className='article-author-head'>{translations.BlogmlroleHealth14}</p>

          </div>

          <div className='mlrole-health-first-image-box'>
            <img src={mlroleHealthImage} alt='mlroleHealthImage' className='mlrole-health-first-image' />
          </div>
          <ArticleListen />
          <ArticleSummary id='mlrolehealth' />
          <div className='mlrole-health-txt-container'>
            <div className='mlrole-health-txt-child-box'>
              <p>{translations.BlogmlroleHealth1}</p>
              <p>{translations.BlogmlroleHealth2}</p>
              <p>{translations.BlogmlroleHealth3}</p>
              <p>{translations.BlogmlroleHealth4}</p>
              <p>{translations.BlogmlroleHealth5} </p>
              <p>{translations.BlogmlroleHealth6}</p>
              <img src={mlroleHealthImage2} alt='mlroleHealthImage2' className='mlroleHealthImage2' />
              <h2 className='article-secondaty-title'>{translations.BlogmlroleHealth7}</h2>
              <p>{translations.BlogmlroleHealth8}</p>
              <p>{translations.BlogmlroleHealth9}</p>
              <p>{translations.BlogmlroleHealth10}</p>
              <p>{translations.BlogmlroleHealth11}</p>
            </div>
          </div>

          <ArticleCta />
          <ArticleNextCta link='/articles/aiInArchitect' title={translations.BlogaiinArchitect} />
        </div>
      </div>
    </Layout>
  )
}

export default Mlrolehealth